import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import type { AxiosRequestConfig } from 'axios';
import { axiosInstance } from './axios-instance';
import { normalizeApiError } from './error-handler';
import type { NormalizedApiError } from '@/types/api.types';

export type AxiosBaseQueryArgs = {
  url: string;
  method?: AxiosRequestConfig['method'];
  data?: unknown;
  params?: unknown;
  headers?: AxiosRequestConfig['headers'];
  signal?: AbortSignal;
};

export const axiosBaseQuery = (): BaseQueryFn<AxiosBaseQueryArgs, unknown, NormalizedApiError> => {
  return async ({ url, method = 'GET', data, params, headers, signal }) => {
    try {
      const result = await axiosInstance.request({ url, method, data, params, headers, signal });
      return { data: result.data };
    } catch (error) {
      return { error: normalizeApiError(error) };
    }
  };
};
